export default "__VITE_ASSET__DLaIInQ6__"